import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n2 = 0, F = function F() {}; return { s: F, n: function n() { return _n2 >= r.length ? { done: !0 } : { done: !1, value: r[_n2++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*! License details at fancyapps.com/license */
function e(e) {
  var t = [],
    n = "undefined" != typeof TouchEvent && e instanceof TouchEvent ? e.touches : e instanceof MouseEvent && "mouseup" !== e.type ? [e] : [];
  var _iterator = _createForOfIteratorHelper(n),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _e = _step.value;
      t.push({
        x: _e.clientX,
        y: _e.clientY,
        ts: Date.now()
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return t;
}
function t(e) {
  var t = [],
    n = "undefined" != typeof TouchEvent && e instanceof TouchEvent ? e.changedTouches : e instanceof MouseEvent ? [e] : [];
  var _iterator2 = _createForOfIteratorHelper(n),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _e2 = _step2.value;
      t.push({
        x: _e2.clientX,
        y: _e2.clientY,
        ts: Date.now()
      });
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return t;
}
function n(e) {
  var t = e[0],
    n = e[1] || t;
  return {
    x: (t.x + n.x) / 2,
    y: (t.y + n.y) / 2,
    ts: n.ts
  };
}
function o(e) {
  var t = e[0],
    n = e[1] || e[0];
  return t && n ? -1 * Math.sqrt((n.x - t.x) * (n.x - t.x) + (n.y - t.y) * (n.y - t.y)) : 0;
}
var s = function s(e) {
    e.cancelable && e.preventDefault();
  },
  i = {
    passive: !1
  },
  c = {
    panThreshold: 5,
    swipeThreshold: 3,
    ignore: ["textarea", "input", "select", "[contenteditable]", "[data-selectable]", "[data-draggable]"]
  };
var a = !1,
  r = !0;
var u = function u(_u, l) {
  var d,
    f,
    h,
    v = Object.assign(Object.assign({}, c), l),
    p = [],
    m = [],
    E = [],
    g = !1,
    w = !1,
    y = !1,
    T = 0,
    b = 0,
    M = 0,
    x = 0,
    L = 0,
    P = 0,
    D = 0,
    X = 0,
    Y = 0,
    j = [],
    k = 0,
    R = 0;
  var z = new Map();
  function A(e) {
    var t = o(m),
      n = o(E),
      s = t && n ? t / n : 0,
      i = Math.abs(D) > Math.abs(X) ? D : X,
      c = {
        srcEvent: d,
        isPanRecognized: g,
        isSwipeRecognized: w,
        firstTouch: p,
        previousTouch: E,
        currentTouch: m,
        deltaX: M,
        deltaY: x,
        offsetX: L,
        offsetY: P,
        velocityX: D,
        velocityY: X,
        velocity: i,
        angle: Y,
        axis: h,
        scale: s,
        center: f
      };
    var _iterator3 = _createForOfIteratorHelper(z.get(e) || []),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _t = _step3.value;
        _t(c);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  function O(e) {
    var t = Date.now();
    j = j.filter(function (e) {
      return !e.ts || e.ts > t - 100;
    }), e && j.push(e);
  }
  function S() {
    if (D = 0, X = 0, j.length > 3) {
      var _e3 = j[0],
        _t2 = j[j.length - 1];
      if (_e3 && _t2) {
        var _n = _t2.x - _e3.x,
          _o = _t2.y - _e3.y,
          _s = _e3.ts && _t2.ts ? _t2.ts - _e3.ts : 0;
        _s > 0 && (D = Math.abs(_n) > 3 ? _n / (_s / 30) : 0, X = Math.abs(_o) > 3 ? _o / (_s / 30) : 0);
      }
    }
  }
  function q(t) {
    if (t instanceof MouseEvent) {
      if (a) return;
    } else a = !0;
    var o = t.composedPath()[0],
      i = v.ignore.join(",");
    if (o.matches(i) || o.closest(i)) return;
    if ("undefined" != typeof MouseEvent && t instanceof MouseEvent && (!t.buttons || 0 !== t.button)) return;
    t instanceof MouseEvent && s(t);
    var c = Date.now(),
      r = c - (T || c);
    y = r > 0 && r <= 250, T = c, clearTimeout(k), d = t, t instanceof MouseEvent && (window.addEventListener("mousemove", C), window.addEventListener("mouseup", I)), window.addEventListener("blur", B), m = e(t), p = _toConsumableArray(m), E = [], b = m.length, f = n(m), 1 === b && (g = !1, w = !1), b && O(n(m)), A("start");
  }
  function C(t) {
    var s;
    if (!p.length) return;
    if (t.defaultPrevented) return;
    d = t, E = _toConsumableArray(m), m = e(t), b = m.length, f = n(m);
    var i = f,
      c = n(E);
    if (M = i.x - c.x, x = i.y - c.y, O(i), S(), A("move"), m.length > 1) {
      var _e4 = o(m),
        _t3 = o(E);
      Math.abs(_e4 - _t3) >= .1 && A("pinch");
    }
    if (!g && p.length) {
      var _e5 = n(p);
      L = i.x - _e5.x, P = i.y - _e5.y, g = Math.abs(L) > v.panThreshold || Math.abs(P) > v.panThreshold, g && (r = !1, clearTimeout(R), R = 0, Y = Math.abs(180 * Math.atan2(P, L) / Math.PI), h = Y > 45 && Y < 135 ? "y" : "x", p = _toConsumableArray(m), E = _toConsumableArray(m), null === (s = window.getSelection()) || void 0 === s || s.removeAllRanges(), A("panstart"));
    }
    g && (M || x) && A("pan");
  }
  function I(o) {
    if (d = o, !p.length) return;
    var s = e(o),
      i = t(o);
    if (b = s.length, f = n(i), i.length && O(n(i)), S(), E = _toConsumableArray(m), m = _toConsumableArray(s), p = _toConsumableArray(s), s.length > 0) A("end"), g = !1, w = !1, j = [];else {
      var _e6 = v.swipeThreshold;
      (Math.abs(D) > _e6 || Math.abs(X) > _e6) && (w = !0), g && A("panend"), w && A("swipe"), g || w || (A("tap"), y ? A("doubleTap") : k = setTimeout(function () {
        A("singleTap");
      }, 250)), A("end"), F();
    }
  }
  function B() {
    clearTimeout(k), F(), g && A("panend"), A("end");
  }
  function F() {
    g = !1, w = !1, y = !1, b = 0, j = [], m = [], E = [], p = [], M = 0, x = 0, L = 0, P = 0, D = 0, X = 0, Y = 0, h = void 0, window.removeEventListener("mousemove", C), window.removeEventListener("mouseup", I), window.removeEventListener("blur", B), r || R || (R = setTimeout(function () {
      r = !0, R = 0;
    }, 100));
  }
  function G(e) {
    var t = e.target;
    a = !1, t && !e.defaultPrevented && (r || (s(e), e.stopPropagation()));
  }
  var H = {
    init: function init() {
      if (_u) return _u.addEventListener("click", G, i), _u.addEventListener("mousedown", q, i), _u.addEventListener("touchstart", q, i), _u.addEventListener("touchmove", C, i), _u.addEventListener("touchend", I), _u.addEventListener("touchcancel", I), H;
    },
    on: function on(e, t) {
      return function (e, t) {
        z.set(e, [].concat(_toConsumableArray(z.get(e) || []), [t]));
      }(e, t), H;
    },
    off: function off(e, t) {
      return z.has(e) && z.set(e, z.get(e).filter(function (e) {
        return e !== t;
      })), H;
    },
    isPointerDown: function isPointerDown() {
      return b > 0;
    },
    destroy: function destroy() {
      clearTimeout(k), clearTimeout(R), R = 0, _u && (_u.removeEventListener("click", G, i), _u.removeEventListener("mousedown", q, i), _u.removeEventListener("touchstart", q, i), _u.removeEventListener("touchmove", C, i), _u.removeEventListener("touchend", I), _u.removeEventListener("touchcancel", I)), _u = null, F();
    }
  };
  return H;
};
u.isClickAllowed = function () {
  return r;
};
export { u as Gestures, t as getChangedPosition, e as getCurrentPosition, o as getDistance, n as getMidpoint };